let interval = setInterval(function () {
  let labelTooltips = document.querySelectorAll(
    "#avpoptions-container__v2 .ap-label-tooltip"
  );
  if (labelTooltips.length) {
    for (let labelTooltip of labelTooltips) {
      let typeIconHoverTooltip = labelTooltip.lastChild.tagName;
      if (typeIconHoverTooltip === "DIV") {
        let lengthLabelTooltip = labelTooltip.offsetWidth;
        let lengthIconHoverTooltip = labelTooltip.lastChild.offsetLeft;
        let elementTooltip = labelTooltip.lastChild.lastChild;

        if (lengthIconHoverTooltip >= lengthLabelTooltip / 2) {
          elementTooltip.style.transform = "translateX(-65%)";
        }
      }
    }
    clearInterval(interval);
  }
}, 100);

let interval2 = setInterval(function () {
  let apElements = document.querySelector("#avpoptions-container__v2");
  let apValueSelect = $(
    ".apo-select-fonts .avp-productdescfont.avp-productoptiontextcolor.avp-productoptionbackground"
  ).val();
  let fontValue = null;
  if (apElements) {
    if (apValueSelect) {
      fontValue = apValueSelect;
      $(".apo-text input").css("font-family", fontValue);
      $(".apo-text textarea").css("font-family", fontValue);
    }
  }

  var inputText =
    $(".avpoptions-container__v2 input[type=text]")?.val()?.trim() === ""
      ? "Voorbeeld"
      : $(".avpoptions-container__v2 input[type=text]")?.val()?.trim();

  if (apValueSelect === "Arial Black") {
    var uppercaseValue = inputText?.toUpperCase();
    $(".apo-preview textarea")?.val(uppercaseValue);
  } else {
    $(".apo-preview textarea")?.val(inputText);
  }
}, 100);

// Disable input in the preview
let interval3 = setInterval(function () {
  let apElements = document.querySelector("#avpoptions-container__v2");
  if (apElements) {
    if ($(".apo-preview textarea")) {
      let textarea = $(".apo-preview textarea");
      textarea.readOnly = true;
      textarea.prop("disabled", true);
    }
  }
}, 100);

// setTimeout(forceQuitInterval, 10000);
// $(function () {
//   if ($(".apo-preview textarea")) {
//     let textarea = $(".apo-preview textarea");
//     textarea.readOnly = true;
//     textarea.prop("disabled", true);
//   }
// });

setInterval(() => {
  const sourceInput = document.querySelector(
    '#product-form-installment input[name="id"]'
  );
  const form = document.querySelector('form.productForm');

  if (!sourceInput || !form) return;

  let targetInput = form.querySelector('input[name="id"]');

  if (!targetInput) {
    targetInput = sourceInput.cloneNode(true);
    form.appendChild(targetInput);
  }

  if (targetInput.value !== sourceInput.value) {
    targetInput.value = sourceInput.value;
    targetInput.setAttribute('value', sourceInput.value);

    targetInput.dispatchEvent(new Event('input', { bubbles: true }));
    targetInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
}, 100);